import {
  IColumn,
  ICommandBarItemProps,
  Icon,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { IDataTablePersonas } from "../../Interfaces/IPersona";
import {
  _initialFilter,
  _initialPagination,
} from "../../utils/helpers/helpers";
import themeBase from "../../utils/theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { ConfigHelper } from "../../utils/helpers/configHelper";
import IconHelper from "../../utils/helpers/iconHelper";
import COLORES from "../../utils/theme/colores";
import ReporteEnrolados from "./ReporteUsuarioEnrolados";
import { CabeceraTable } from "../../components/Table/CabeceraTable";
import { TableBase2 } from "../../components/Table/TableBase2";
import { PanelFilterPersonasView } from "./PanelFilterPersonasView";
import { useTablaPersonas } from "../../hooks/Personas/useTablaPersonas";
import { PaginationFooterC } from "../../components/PaginationFooter/PaginationFooterC";

function PersonasView() {
  const navigate = useNavigate();
  const {
    items,
    onChangeCombos,
    searchBoxRefTable,
    filterPersona,
    _onkeyUpSearchArea,
    onChangeSkip,
    paginacion,
    isLoading,
    limpiarFiltro,
    getTablaPersonas,
    ActualizarTable
  } = useTablaPersonas();

  const [isOpenReporte, { setTrue: openReporte, setFalse: dismissReporte }] =
    useBoolean(false);
  const [isOpenFiltro, { setTrue: openFiltro, setFalse: dismissFiltro }] =
    useBoolean(false);

  const _itemsLeftBar: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        ActualizarTable()

      },
    },
    {
      ...IconHelper.ICON_FILTER,
      text: "Limpiar Filtro",
      onClick: () => {
        limpiarFiltro();
      },
    },
  ];
  const _itemRigthBar: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_EXCEL,
      onClick: openReporte,
    },
    {
      ...IconHelper.ICON_BS_FILTER,
      text: `Buscar`,
      onClick: openFiltro,
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "persona",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      isSorted: true,
      isSortedDescending: true,
    },
    {
      key: "equipo",
      name: "DNI",
      fieldName: "dni",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      onRender: (item: IDataTablePersonas) => (
        <span style={{ fontWeight: "bold", fontSize: 12 }}>{item.dni}</span>
      ),
    },
    {
      key: "codSap",
      name: "Código SAP",
      fieldName: "codigoSap",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "guardia",
      name: "Guardia",
      fieldName: "guardia",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "modelo",
      name: "Área",
      fieldName: "area",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "Cargo",
      name: "Puesto",
      fieldName: "puesto",
      minWidth: 250,
      maxWidth: 250,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "email",
      name: "Email",
      fieldName: "email",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      onRender: (item: IDataTablePersonas) => (
        <>
          <TooltipHost content="Detalle">
            <Icon
              iconName="NumberedListText"
              style={{ cursor: "pointer", color: COLORES.Bases.primary }}
              className={themeBase.classNamesIcon.iconFont}
              onClick={() => {
                navigate(
                  `${ConfigHelper.urlBase()}/DetallePersona/${item?.personaId}`
                );
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Nombre/DNI"
            Titulo="Personas"
            SubTitulo="Gestión de Personas"
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearchArea}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_itemsLeftBar}
          rigthBar={_itemRigthBar}
          data={items}
          column={_columns}
          isLoading={isLoading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      {/* <pre>{JSON.stringify(items, null,2)}</pre> */}
      <ReporteEnrolados
        isOpen={isOpenReporte}
        onDismiss={dismissReporte}
      />
      <PanelFilterPersonasView
        limpiarFiltro={limpiarFiltro}
        isOpen={isOpenFiltro}
        onDismiss={dismissFiltro}
        filter={filterPersona}
        onChangeComboBox={onChangeCombos}
        buscar={getTablaPersonas}
      />
    </>
  );
}
export default PersonasView;
